import React from 'react';
import HtmlDisplay from "./html_display";

const FixedLengthText = ({ text, maxLength }) => {
  // Truncate or limit the text to the specified maxLength
  // console.log("maxLength-----", maxLength)
  // console.log("text.length-----", text.length)
  const truncatedText = text?.length > maxLength ? text?.slice(0, maxLength) + '...' : text;

  return (
    <p>
      {/* <p>{truncatedText}</p> */}
      <HtmlDisplay data={truncatedText} />
    </p>
  );
};

export default FixedLengthText;
